module.exports = __webpack_public_path__ + "img/1.6b61e96d.jpg";